/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerGoogleAnalyticsSourceComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerSchema',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerSchema) {
      function DesignerGoogleAnalyticsSourceComponent() {
        this.cloud_storage_connection_id = null;

        this.profile_ids = null;
        this.account_name_field_alias = null;
        this.property_name_field_alias = null;
        this.profile_name_field_alias = null;
        this.profile_id_field_alias = null;

        this.report_date_range_type = null;
        this.report_date_range_min = null;
        this.report_date_range_max = null;

        this.segment = null;
        this.filters = null;
        this.sort = null;
        this.include_empty_rows = null;
        this.report_sampling_level = null;

        this.availableFields = [];

        this.metrics = [];
        this.dimensions = [];
        this.quota_user = null;

        DesignerBaseSourceAndDestinationComponent.apply(this);
      }

      DesignerGoogleAnalyticsSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      const dataRangeOptions = [
        {
          min: 'today',
          max: 'today',
          value: 'TODAY',
        },
        {
          min: 'yesterday',
          max: 'yesterday',
          value: 'YESTERDAY',
        },
        {
          min: '3daysAgo',
          max: 'today',
          value: 'LAST_3_DAYS',
        },
        {
          min: '7daysAgo',
          max: 'today',
          value: 'LAST_7_DAYS',
        },
        {
          min: '14daysAgo',
          max: 'today',
          value: 'LAST_14_DAYS',
        },
        {
          min: '30daysAgo',
          max: 'today',
          value: 'LAST_30_DAYS',
        },
        {
          min: '2005-01-01',
          max: 'today',
          value: 'ALL_TIME',
        },
        {
          min: '',
          max: '',
          value: 'CUSTOM_DATE',
        },
      ];

      DesignerGoogleAnalyticsSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          profile_ids: this.profile_ids || this.defaults.profile_ids,

          account_name_field_alias: this.account_name_field_alias || this.defaults.account_name_field_alias,
          property_name_field_alias: this.property_name_field_alias || this.defaults.property_name_field_alias,
          profile_name_field_alias: this.profile_name_field_alias || this.defaults.profile_name_field_alias,
          profile_id_field_alias: this.profile_id_field_alias || this.defaults.profile_id_field_alias,
          report_on: this.report_on || this.defaults.report_on,

          segment: this.segment || this.defaults.segment,
          filters: this.filters || this.defaults.filters,
          sort: this.sort || this.defaults.sort,

          include_empty_rows: angular.isDefined(this.include_empty_rows)
            ? this.include_empty_rows
            : this.defaults.include_empty_rows,
          report_sampling_level: this.report_sampling_level || this.defaults.report_sampling_level,

          report_date_range_min: this.report_date_range_min || this.defaults.report_date_range_min,
          report_date_range_max: this.report_date_range_max || this.defaults.report_date_range_max,
          manual_breakdown: this.manual_breakdown || this.defaults.manual_breakdown,

          metrics: this.metrics,
          dimensions: this.dimensions,
          quota_user: this.quota_user,
        });

        return data;
      };

      DesignerGoogleAnalyticsSourceComponent.prototype.setFormData = function (data) {
        // server can only get range type as custom type
        if (data.report_date_range_type !== 'CUSTOM_DATE') {
          data.manual_breakdown = 'Default';
          const dateRange = _.find(dataRangeOptions, { value: data.report_date_range_type });
          if (dateRange) {
            data.report_date_range_type = 'CUSTOM_DATE';
            data.report_date_range_min = dateRange.min;
            data.report_date_range_max = dateRange.max;
          }
        }

        const accountNameIndex = _.findIndex(data.schema.fields, { name: 'account_name' });

        if (accountNameIndex > -1) {
          data.account_name_field_alias = data.schema.fields[accountNameIndex].alias;
          data.schema.fields.splice(accountNameIndex, 1);
        }

        const propertyNameIndex = _.findIndex(data.schema.fields, { name: 'property_name' });

        if (propertyNameIndex > -1) {
          data.property_name_field_alias = data.schema.fields[propertyNameIndex].alias;
          data.schema.fields.splice(propertyNameIndex, 1);
        }

        const profileNameIndex = _.findIndex(data.schema.fields, { name: 'profile_name' });

        if (profileNameIndex > -1) {
          data.profile_name_field_alias = data.schema.fields[profileNameIndex].alias;
          data.schema.fields.splice(profileNameIndex, 1);
        }

        const profileIdIndex = _.findIndex(data.schema.fields, { name: 'profile_id' });

        if (profileIdIndex > -1) {
          data.profile_id_field_alias = data.schema.fields[profileIdIndex].alias;
          data.schema.fields.splice(profileIdIndex, 1);
        }

        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerGoogleAnalyticsSourceComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.profile_ids = data.profile_ids;
        this.report_date_range_type = data.report_date_range_type;
        this.report_date_range_min = data.report_date_range_min;
        this.report_date_range_max = data.report_date_range_max;
        this.manual_breakdown = data.manual_breakdown;
        this.account_name_field_alias = data.account_name_field_alias;
        this.property_name_field_alias = data.property_name_field_alias;
        this.profile_name_field_alias = data.profile_name_field_alias;
        this.profile_id_field_alias = data.profile_id_field_alias;
        this.quota_user = data.quota_user;

        this.segment = data.segment;
        this.filters = data.filters;
        this.sort = data.sort;

        this.include_empty_rows = data.include_empty_rows;
        this.report_sampling_level = data.report_sampling_level;

        this.metrics = data.metrics;
        this.dimensions = data.dimensions;

        this.report_on = data.report_on;
        if (!this.report_on) {
          if (!this.profile_ids) this.report_on = 'all';
          else if (this.profile_ids.charAt(0) === '$') this.report_on = 'custom';
          else this.report_on = 'specific';
        }

        if (this.report_on === 'all') {
          this.profile_ids = '';
        }

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerGoogleAnalyticsSourceComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();
        const _this = this;

        schema.id = this.id;
        schema.name = this.name;

        const getFieldAlias = function (fieldName) {
          return _.find(_this.schema.fields, { name: fieldName }).alias;
        };

        schema.fields.push({
          name: this.profile_id_field_alias,
        });

        schema.fields.push({
          name: this.account_name_field_alias,
        });

        schema.fields.push({
          name: this.property_name_field_alias,
        });

        schema.fields.push({
          name: this.profile_name_field_alias,
        });

        _.each(this.dimensions, function (dimension) {
          schema.fields.push({
            name: getFieldAlias(dimension),
          });
        });

        _.each(this.metrics, function (metric) {
          schema.fields.push({
            name: getFieldAlias(metric),
          });
        });

        return schema;
      };

      return DesignerGoogleAnalyticsSourceComponent;
    },
  ]);
})(window.angular);
